import React from 'react'
import VendorLogin from '../../Components/Vendor/VendorLogin'

function LoginPage() {
  return (
    <div>
       <VendorLogin/>
    </div>
  )
}

export default LoginPage
